import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FnLoaderService } from './loader.service';

/**
 * Component used to show Loader 
 * To use this component import FnLoaderModule in Module.
 */
@Component({
  selector: 'fn-loader',
  templateUrl: './loader.component.html',
  encapsulation: ViewEncapsulation.None
})
export class FnLoaderComponent {

  /**
   * Creates an instance of fn loader component.
   * @param loaderService getting ref of LoaderServie 
   */
  constructor(public loaderService: FnLoaderService) { }
}
